import React from 'react';
import imageNaissance from '../Images/Grande-Loge-Régulière-Mixte-Internal-naissance.png';
import imageOrigines from '../Images/Grande-Loge-Régulière-Mixte-Internal-origines.png';
import imageStructure from '../Images/Grande-Loge-Régulière-Mixte-Internal-Structure.png';
import imageInternational from '../Images/Grande-Loge-Régulière-Mixte-Internal-International.png';
import imageValeurs from '../Images/Grande-Loge-Régulière-Mixte-Internal-Valeurs.png';
import './Accueil.css';

function Accueil() {
  return (
    <>
      {/* SECTION 1 - UNE NAISSANCE PORTEUSE D'ESPOIR - IMAGE À DROITE */}
      <section className="content-section">
        <div className="section-title">Une Naissance Porteuse d'Espoir</div>
        <div className="content-wrapper">
          <div className="text-zone">
            <p>
              Née officiellement en mai 2023, à l'Orient de Bormes les Mimosas, la GLRMI est le fruit d'une 
              réflexion commune de Sœurs et de Frères usés et déçus par le fonctionnement des obédiences 
              dites institutionnelles.
            </p>
            <p>
              Issus de structures maçonniques diverses (GLTSO, GLMF, GLFF, GLNF…) ces Hommes et ces Femmes, 
              expérimentés et de qualité se sont réunis, souhaitant apporter un souffle nouveau à leur parcours 
              maçonnique et poursuivre le chemin initiatique inachevé qui était le leur.
            </p>
          </div>
          <div className="image-zone">
            <img 
              src={imageNaissance} 
              alt="Naissance de la GLRMI" 
            />
          </div>
        </div>
      </section>

      {/* SECTION 2 - NOS ORIGINES - IMAGE À GAUCHE */}
      <section className="content-section content-section-alt">
        <div className="section-title">Nos Origines</div>
        <div className="content-wrapper">
          {/* IMAGE EN PREMIER pour qu'elle soit à gauche */}
          <div className="image-zone">
            <img 
              src={imageOrigines} 
              alt="Les origines de la GLRMI" 
            />
          </div>
          {/* TEXTE EN SECOND */}
          <div className="text-zone">
            <p>
              La première Loge créée, « Les Trois Colonnes » au Rite Français, fut ainsi pionnière dans cette 
              démarche à s'inscrire dans la continuité de ce projet. D'autres Loges ont suivi : REAA, 
              Memphis-Misraïm, Adama. Alors a germé l'idée de créer une Fédération d'association : la Fédération 
              d'Associations « Joséphine Baker ».
            </p>
            <p>
              La création de l'Obédience qui en a découlé est vite devenue une évidence, tant l'espoir suscité 
              par ce retour aux sources a été porteur.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 3 - NOTRE STRUCTURE AUJOURD'HUI - IMAGE À DROITE */}
      <section className="content-section">
        <div className="section-title">Notre Structure Aujourd'hui</div>
        <div className="content-wrapper">
          <div className="text-zone">
            <p>
              À ce jour, la GLRMI compte une centaine de membres répartis sur 8 Ateliers allant de Bordeaux, 
              Perpignan, Toulon et Nice. Multi rites et ouverte d'esprit, notre Obédience s'enorgueillit de 
              considérer chaque Loge comme souveraine, et n'interfère en rien dans le fonctionnement de chacune 
              d'elle.
            </p>
            <p>
              D'autres Loges sont en cours de création, notamment une Loge Magistrale dont les feux seront allumés 
              le 15 mai 2025. Qu'elle soit mixte, féminine ou masculine, chaque Loge qui compose notre structure 
              est unique et précieuse.
            </p>
          </div>
          <div className="image-zone">
            <img 
              src={imageStructure} 
              alt="Structure de la GLRMI" 
            />
          </div>
        </div>
      </section>

      {/* SECTION 4 - NOS RELATIONS INTERNATIONALES - IMAGE À GAUCHE */}
      <section className="content-section content-section-alt">
        <div className="section-title">Nos Relations Internationales</div>
        <div className="content-wrapper">
          {/* IMAGE EN PREMIER pour qu'elle soit à gauche */}
          <div className="image-zone">
            <img 
              src={imageInternational} 
              alt="Relations internationales de la GLRMI" 
            />
          </div>
          {/* TEXTE EN SECOND */}
          <div className="text-zone">
            <p>
              À ce jour, un pont sur la méditerranée a été bâti par le biais d'un traité d'amitié signé avec la 
              Grande Loge Mixte du Maroc, et d'autres sont à l'étude et en discussion, en l'occurrence avec l'Italie.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 5 - NOS VALEURS - IMAGE À DROITE */}
      <section className="content-section">
        <div className="section-title">Nos Valeurs</div>
        <div className="content-wrapper">
          <div className="text-zone">
            <p>
              Nous considérons, toutes et tous, Sœurs et Frères, qu'au-delà du tablier que nous portons, qu'au-delà 
              du rite auquel nous travaillons, la Franc-Maçonnerie est avant tout un état d'esprit, porteur de valeurs 
              séculaires et nobles, que nous nous devons de continuer à véhiculer, tant en notre sein que dans le monde 
              profane.
            </p>
            <p>
              Des valeurs telles que la fraternité, la transmission, l'humanité, la charité et encore bien d'autres. 
              La GLRMI se fait et se fera l'honneur d'être la place forte de la défense de toutes ces valeurs morales 
              qui sont les nôtres, et telles que les anciens nous ont légué.
            </p>
        </div>
          <div className="image-zone">
            <img 
              src={imageValeurs} 
              alt="Nos valeurs" 
            />
          </div>
        </div>
      </section>
    </>
  );
}

export default Accueil;